import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeData";

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-10 h-16 md:h-[72px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group">
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-heading font-black text-lg leading-none">
            黑
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading font-black text-foreground-950 text-base md:text-lg tracking-wide">
              黑料爆料
            </span>
            <span className="font-label text-[10px] md:text-[11px] text-foreground-500 tracking-[0.22em] mt-1">
              证据式整理 · 原样呈现
            </span>
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={link.href}
                className="font-label text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#library"
            className="hidden md:inline-flex items-center gap-2 rounded-md bg-foreground-950 text-background-50 px-4 py-2.5 font-label text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-folder-open-line text-base" aria-hidden="true"></i>
            打开材料库
          </a>
          <button
            type="button"
            aria-label="展开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200 px-4 pb-5 pt-1">
          <ul className="flex flex-col">
            {navLinks.map((link) => (
              <li key={link.id} className="border-b border-background-200/70 last:border-0">
                <a
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="block py-3 font-label text-sm text-foreground-800 hover:text-primary-600 transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#library"
            onClick={() => setMenuOpen(false)}
            className="mt-4 w-full inline-flex items-center justify-center gap-2 rounded-md bg-foreground-950 text-background-50 px-4 py-3 font-label text-sm"
          >
            <i className="ri-folder-open-line text-base" aria-hidden="true"></i>
            打开材料库
          </a>
        </div>
      )}
    </header>
  );
}